{
    "NAME": "InboundStatSettings",
    "InboundStatSettings_SectionHeader": "Inbound Statistic Settings",
    "InboundStatSettings_SectionPara": "You can adjust the following settings to specifically control how the current report calculates all other inbound call related statistics. Short abandoned and/or overflowed calls are also immediately excluded from historic call list and unreturned lost call reports.",
    "InboundStatSettings_IgnorequickabndcallswithinLabel": "Ignore Quick Abandoned Calls Within:",
    "InboundStatSettings_IgnorequickabndcallswithinPlaceholder": "5",
    "InboundStatSettings_IgnorequickabndcallswithinEnabledHiddenlabel": "Is \"Ignore Quick Abandoned Calls Within\" Setting Enabled?",
    "InboundStatSettings_IgnorequickabndcallswithinUnit": "s",
    "InboundStatSettings_IgnoreovrflwdcallswithinLabel": "Ignore Overflowed Calls Within:",
    "InboundStatSettings_IgnoreovrflwdcallswithinPlaceholder": "5",
    "InboundStatSettings_IgnoreovrflwdcallswithinEnabledHiddenlabel": "Is \"Ignore Overflowed Calls Within\" Setting Enabled?",
    "InboundStatSettings_IgnoreovrflwdcallswithinUnit": "s",
    "InboundStatSettings_IgnoreEscapedCalls": "Ignore Escaped Calls"
}
